import React from "react";
import { Container } from "@mui/material";
import MonthPicker from "../components/MonthPicker";
import WeekPicker from "../components/WeekPicker";
import { Button, Stack, Box, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EmployeePicker from "../components/EmployeePicker";
import ExpenseTabs from "../components/ExpenseTabs";
import PerDiemDataService from "../services/PerDiem.services";
import { pink } from "@mui/material/colors";
import { blue } from "@mui/material/colors";
import { orange } from "@mui/material/colors";
import { green } from "@mui/material/colors";
import moment from "moment";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export default function Expenses(props) {
    const { user, token, handleOpenSnackbar, darkState } = props;
    const { employees } = props;
    const [employee, setEmployee] = React.useState(null);
    const [month, setMonth] = React.useState(new Date());
    const [perDiemIsoWeek, setPerDiemIsoWeek] = React.useState(
        moment().format("GGGG[W]WW")
    );
    const [perDiemRates, setPerDiemRates] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [openMiles, setOpenMiles] = React.useState(false);
    const [openPerDiem, setOpenPerDiem] = React.useState(false);
    const [editing, setEditing] = React.useState(false);
    const [tabIndex, setTabIndex] = React.useState("");
    const [isAdmin, setIsAdmin] = React.useState(false);

    React.useEffect(() => {
        //* set admin
        if (user.groups.some((group) => group.name === "MANAGEMENT")) {
            setIsAdmin(true);
            // Set current user as default selected employee for admin users
            // Find the current user in the employees array
            const currentUserEmployee = employees.find(
                (emp) => emp.id === user.id
            );
            if (currentUserEmployee) {
                setEmployee(currentUserEmployee);
            } else {
                // Fallback to user object if not found in employees array
                setEmployee(user);
            }
        }
        // Fetch per diem rates
        fetchPerDiemRates();
    }, [user, employees]);

    const fetchPerDiemRates = () => {
        if (!token) return;

        PerDiemDataService.getAllRates(token)
            .then((response) => {
                setPerDiemRates(response.data || []);
            })
            .catch((e) => {
                console.log(e);
                handleOpenSnackbar(
                    "error",
                    "Something went wrong fetching per diem rates! Please try again."
                );
            });
    };

    const handleClickOpen = () => {
        if (tabIndex === 2) {
            setOpenMiles(true);
            setEditing(false);
        } else if (tabIndex === 3) {
            setOpenPerDiem(true);
            setEditing(false);
        } else {
            setOpen(true);
            setEditing(false);
        }
    };

    const handleChangeEmployee = (newEmployee) => {
        setEmployee(newEmployee);
    };

    const handleChangeMonth = (newMonth) => {
        setMonth(newMonth);
    };

    const handleChangeIsoWeek = (newIsoWeek) => {
        setPerDiemIsoWeek(newIsoWeek);
    };

    const handleMoveIsoWeek = (direction) => {
        setPerDiemIsoWeek((prev) => {
            const base = moment(prev, "GGGG[W]WW", true);
            const safe = base.isValid() ? base : moment();
            return safe.add(direction, "week").format("GGGG[W]WW");
        });
    };

    const CONTROL_HEIGHT = 56;

    return (
        <div style={{ paddingTop: "1rem" }}>
            <Container
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    height: "100%",
                }}
            >
                <div style={{ width: "100%", maxWidth: "500px" }}>
                    <Stack
                        style={{ marginBottom: "0.75rem", marginTop: "1.5rem" }}
                        direction="row"
                        spacing={2}
                        alignItems="center"
                    >
                        {tabIndex !== 3 ? (
                            <Box sx={{ flexShrink: 0 }}>
                                <MonthPicker
                                    handleChangeMonth={handleChangeMonth}
                                />
                            </Box>
                        ) : null}
                        {tabIndex === 3 ? (
                            <Stack
                                spacing={2}
                                sx={{
                                    flexGrow: 1,
                                    flexShrink: 0,
                                    width: "100%",
                                    mb: 1,
                                }}
                            >
                                <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="center"
                                    sx={{ flexShrink: 0 }}
                                >
                                    <Box
                                        sx={{
                                            "& .MuiButton-root": {
                                                height: CONTROL_HEIGHT,
                                            },
                                        }}
                                    >
                                        <WeekPicker
                                            isoWeek={perDiemIsoWeek}
                                            getIsoWeek={handleChangeIsoWeek}
                                        />
                                    </Box>
                                    <IconButton
                                        color="primary"
                                        aria-label="previous week"
                                        onClick={() => handleMoveIsoWeek(-1)}
                                        sx={{
                                            height: CONTROL_HEIGHT,
                                            width: CONTROL_HEIGHT,
                                        }}
                                    >
                                        <ArrowBackIosNewIcon />
                                    </IconButton>
                                    <IconButton
                                        color="primary"
                                        aria-label="next week"
                                        onClick={() => handleMoveIsoWeek(1)}
                                        sx={{
                                            height: CONTROL_HEIGHT,
                                            width: CONTROL_HEIGHT,
                                        }}
                                    >
                                        <ArrowForwardIosIcon />
                                    </IconButton>
                                </Stack>
                                <Box sx={{ flexGrow: 1, width: "100%" }}>
                                    <Button
                                        sx={{
                                            width: "100%",

                                            height: CONTROL_HEIGHT,
                                            minHeight: CONTROL_HEIGHT,
                                            backgroundColor: orange[500],
                                            "&:hover": {
                                                backgroundColor: orange[700],
                                            },
                                        }}
                                        size="large"
                                        variant="contained"
                                        endIcon={<AddIcon />}
                                        onClick={handleClickOpen}
                                    >
                                        Add
                                    </Button>
                                </Box>
                            </Stack>
                        ) : null}

                        <Box sx={{ flexGrow: 1 }}>
                            {tabIndex !== 3 ? (
                                <Button
                                    sx={{
                                        width: "100%",
                                        height: CONTROL_HEIGHT,
                                        minHeight: CONTROL_HEIGHT,
                                        backgroundColor:
                                            tabIndex === 0
                                                ? green[500]
                                                : tabIndex === 1
                                                ? pink[500]
                                                : tabIndex === 2
                                                ? blue[500]
                                                : orange[500],
                                        "&:hover": {
                                            backgroundColor:
                                                tabIndex === 0
                                                    ? green[700]
                                                    : tabIndex === 1
                                                    ? pink[700]
                                                    : tabIndex === 2
                                                    ? blue[700]
                                                    : orange[700],
                                        },
                                    }}
                                    size="large"
                                    variant="contained"
                                    endIcon={<AddIcon />}
                                    onClick={handleClickOpen}
                                >
                                    Add
                                </Button>
                            ) : null}
                        </Box>
                    </Stack>
                    {isAdmin ? (
                        <div style={{ marginBottom: "0.25rem" }}>
                            <EmployeePicker
                                user={user}
                                editing={false}
                                editObject={{}}
                                employee={employee}
                                token={token}
                                handleChangeEmployee={handleChangeEmployee}
                                employees={employees}
                            />
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                <ExpenseTabs
                    darkState={darkState}
                    employees={employees}
                    setTabIndex={setTabIndex}
                    editing={editing}
                    setEditing={setEditing}
                    employee={employee}
                    token={token}
                    handleOpenSnackbar={handleOpenSnackbar}
                    month={month}
                    perDiemIsoWeek={perDiemIsoWeek}
                    perDiemRates={perDiemRates}
                    user={user}
                    onIsoWeekChange={handleChangeIsoWeek}
                    open={open}
                    setOpen={setOpen}
                    openMiles={openMiles}
                    setOpenMiles={setOpenMiles}
                    openPerDiem={openPerDiem}
                    setOpenPerDiem={setOpenPerDiem}
                    handleChangeEmployee={handleChangeEmployee}
                    isAdmin={isAdmin}
                />
            </Container>
        </div>
    );
}
